import angularModule from 'Careers/angularModule/scripts/careers_module';
import template from 'Careers/angularModule/views/edit_career_profile/application_questions_form.html';
import cacheAngularTemplate from 'cacheAngularTemplate';
import { Brand, setupBrandNameProperties } from 'AppBranding';

const templateUrl = cacheAngularTemplate(angularModule, template);

const MIN_CHAR_COUNT = 400;

angularModule.directive('applicationQuestionsForm', [
    '$injector',
    function factory($injector) {
        const FormHelper = $injector.get('FormHelper');
        const EditCareerProfileHelper = $injector.get('EditCareerProfileHelper');
        const answersTooShortHelper = $injector.get('answersTooShortHelper');
        const TranslationHelper = $injector.get('TranslationHelper');
        const Cohort = $injector.get('Cohort');

        return {
            restrict: 'E',
            // see STEP_FORM_ATTRS in edit_career_profile_dir.js
            scope: {
                // form-step-validity reads this by name off the scope. See STEP_FORM_ATTRS.
                $setValidity: '<setValidity',
                careerProfile: '<',
                currentUser: '<',
                formContext: '<',
                programFamilyFormDatum: '<',
                programType: '<',
                steps: '<',
            },
            templateUrl,
            link(scope) {
                setupBrandNameProperties($injector, scope, {
                    branding: () => scope.currentUser && Cohort.branding(scope.programType),
                });

                const branding = Cohort.branding(scope.programType);
                scope.brandName = branding === Brand.valar ? scope.brandNameStandard : scope.brandNameLong;

                const translationHelper = new TranslationHelper(
                    'careers.edit_career_profile.application_questions_form',
                );

                EditCareerProfileHelper.logEventForApplication(scope.formContext, 'viewed-application-questions');
                FormHelper.supportForm(scope, scope.application_questions);

                scope.howHearPlaceholder = translationHelper.get('how_hear_placeholder');
                scope.howHearOptionKeys = [
                    'google_or_apple_app_store',
                    'linkedin',
                    'llm_chatbot',
                    'meta',
                    'news',
                    'reddit',
                    'search_engine',
                    'word_of_mouth',
                    'other',
                ];

                // Read the config from the step list this form is rendering, rather than looking it up on the
                // cohort a second time.
                const applicationQuestionsForm = scope.steps.find(
                    formConfig => formConfig.stepName === 'application_questions',
                );

                // `inputs` carries metadata for every path this step's schema can fail on, which
                // includes how_did_you_hear_about_us. That one is a select rather than a short answer,
                // so it is not in this list. `maxCharLength` marks the fields write-text-about renders.
                scope.shortAnswerFieldConfigs = Object.entries(applicationQuestionsForm.inputs)
                    .filter(([, config]) => config.maxCharLength !== undefined)
                    .map(([key, config]) => ({
                        key,
                        ...config,
                    }));

                scope.$on('beforeSaveForm', (_e, shouldSaveForm) => {
                    const modalNotShown = !answersTooShortHelper.maybeShowModal(
                        scope.programFamilyFormDatum,
                        scope.shortAnswerFieldConfigs.map(({ key }) => key).filter(v => v !== 'anythingElseToTellUs'),
                        MIN_CHAR_COUNT,
                    );

                    shouldSaveForm(modalNotShown);
                });
            },
        };
    },
]);
